if (!customElements.get('masi-standards')) {
  customElements.define('masi-standards', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if ('IntersectionObserver' in window && !reduceMotion.matches) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.dataset.entered = 'true';
            this.observer.unobserve(entry.target);
          });
        }, { threshold: .25 });
        this.observer.observe(this.querySelector('.mqv-science'));
      }
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      this.dataset.dialogs = 'ready';
      this.querySelectorAll('[data-mqv-open]').forEach(trigger => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const source = this.querySelector(trigger.hash);
          if (!source) return;
          event.preventDefault();
          this.trigger = trigger;
          this.dialog.querySelector('h2').textContent = source.querySelector('summary').textContent;
          this.dialog.querySelector('[data-mqv-body]').replaceChildren(source.querySelector('[data-mqv-content]').cloneNode(true));
          this.dialog.showModal();
          this.dialog.querySelector('.mqv-dialog-body').scrollTop = 0;
          document.documentElement.classList.add('mqv-dialog-open');
        }, options);
      });
      this.querySelector('[data-mqv-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mqv-dialog-open');
        this.trigger?.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('mqv-dialog-open');
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      delete this.dataset.dialogs;
    }
  });
}
